import { useCallback } from "react";
import { useRouter } from "next/router";
import { pathJoinHttp } from "@Utils/url";
import { useAppSelector } from "@wff/store/hooks";

interface PushOptions {
  skipLocale?: boolean; // skip locale prefix
}

export const useLocaleRouter = () => {
  const router = useRouter();
  const localeSlice = useAppSelector((state) => state.locale);
  const languageCode = localeSlice?.languageCode;

  const getLocalePath = useCallback(
    (path = "") => {
      return pathJoinHttp(`/${languageCode}/`, path);
    },
    [languageCode]
  );

  const push = useCallback(
    (to: string, options?: PushOptions) => {
      const { skipLocale } = options || {
        skipLocale: false,
      };

      if (skipLocale) {
        return router.push(to);
      }

      router.push(pathJoinHttp(`/${languageCode}/`, to));
    },
    [languageCode, router]
  );

  return { languageCode, ...router, push, getLocalePath };
};
